export default function () {
    return [
        { "role": "operator", "resource": "user", "action": "read:own", "attributes": "*" },
        { "role": "operator", "resource": "user", "action": "update:own", "attributes": ["details.firstname", "details.lastname", "details.nationalId"] },
        { "role": "operator", "resource": "design", "action": "create:own", "attributes": ["name", "size.width", "size.height"] },
        { "role": "operator", "resource": "design", "action": "read:own", "attributes": "*" },
        { "role": "operator", "resource": "design", "action": "update:own", "attributes": "*" },
        { "role": "operator", "resource": "template", "action": "read:any", "attributes": "*" },
        { "role": "operator", "resource": "template", "action": "create:any", "attributes": "*" },
        { "role": "operator", "resource": "template", "action": "update:any", "attributes": ["name", "price", "description", "tags", "tagsFa"] },
        { "role": "operator", "resource": "resource", "action": "read:any", "attributes": "*" },
        { "role": "operator", "resource": "resource", "action": "update:any", "attributes": "*" },
        { "role": "operator", "resource": "resource", "action": "create:any", "attributes": "*" },
    ];

}
